import PropTypes from 'prop-types';
import React from 'react';
import t from '../../lib/I18n';
import config from '../../config';
import _ from 'lodash';

import SmartcardRegistration from '../../records/customer/SmartcardRegistration';

import { SignupTypes } from '../../constants/AppConstants';
import ValidatedField from '../form/ValidatedField';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import ExternalLink from '../general/ExternalLink';
import FeatureFlag from '../general/FeatureFlag';
import SmartcardBenefits from './SmartcardBenefits';
import OrderStore from '../../stores/OrderStore';
import connectToStores from '../../helpers/connectToStores';

function _getStateFromStores () {
    return {
        currentOrder: OrderStore.getCurrent()
    };
}

class RegisterOptions extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        onContinueWithoutSmartcard: PropTypes.func,
        smartcard: PropTypes.instanceOf(SmartcardRegistration).isRequired,
        enableKeyGoRegistrationAtSignup: PropTypes.bool,
        enableSmartcardTransferAtSignUp: PropTypes.bool,
        forceSignup: PropTypes.bool,
        hideSmartcardCheckbox: PropTypes.bool,
        onContintueWithoutSmartcard: PropTypes.func,
        customPromotionalText: PropTypes.string,
        showBenefits: PropTypes.bool,
        currentOrder: PropTypes.object
    };

    static defaultProps = {
        forceSignup: false,
        enableSmartcardTransferAtSignUp: false,
        enableKeyGoRegistrationAtSignup: false,
        hideSmartcardCheckbox: false,
        showBenefits: false,
        currentOrder: null,
        onContinueWithoutSmartcard: _.noop,
    };

    _renderSignupDetails = () => {
        const {
            smartcard,
            currentOrder,
            enableSmartcardTransferAtSignUp,
            enableKeyGoRegistrationAtSignup,
            customPromotionalText,
            showBenefits,
        } = this.props;

        const hasFlexiFare = currentOrder && currentOrder.getFares().some(x => x.isFlexi());

        if (smartcard.withSmartcard() || (smartcard.withoutSmartcard() && !enableSmartcardTransferAtSignUp) ) {
            return (
                <div>
                    {hasFlexiFare && <p><strong>{t('account.smartcardsignup.flexi')}</strong></p>}
                    <p>
                        { customPromotionalText
                            ||
                        <FormattedHTMLMessage
                            message='account.smartcardsignup.details'
                            readmore={
                                <ExternalLink
                                    message={ t('account.smartcardsignup.readmore') }
                                    href={ config.get('smartcardReadMoreUrl') }
                                />
                            }
                        />
                        }
                    </p>

                    { showBenefits && <SmartcardBenefits /> }

                    { enableKeyGoRegistrationAtSignup && <p>
                        <FormattedHTMLMessage message='account.smartcard.keygo.signup' />
                    </p> }
                    <FeatureFlag name="enableAutoDelayRepay">
                        <p>
                            <FormattedHTMLMessage
                                message='account.smartcardsignup.autoDelayRepay'
                                moreInformation={
                                    <ExternalLink
                                    message={ t('account.smartcardsignup.moreInformation') }
                                    href={ config.get('autoDelayRepayInformationUrl') }
                                    />
                                }
                                />
                        </p>
                    </FeatureFlag>
                </div>
            );
        } else if (smartcard.withTransfer()) {
            return (
                <p>
                    <FormattedHTMLMessage message='account.register.withPaperTransfers.details' />
                </p>
            );
        }
        return null;
    };

    _handleSignupToggle = () => {
        const { onChange, smartcard } = this.props;
        const signupType = smartcard.withSmartcard() ? SignupTypes.WITHOUT_SMARTCARD : SignupTypes.WITH_SMARTCARD;
        onChange('signup', signupType);
    };

    render () {
        const { smartcard,
            onChange,
            forceSignup,
            enableSmartcardTransferAtSignUp,
            hideSmartcardCheckbox
        } = this.props;

        if (enableSmartcardTransferAtSignUp) {
            return (
                <div>
                    <ValidatedField type="radio"
                        form={ smartcard }
                        id="signup"
                        field="signup"
                        label={ t('account.confirm.smartcardsignup') }
                        onChange={ () => { onChange('signup', SignupTypes.WITH_SMARTCARD);} }
                        checked={ smartcard.withSmartcard() || forceSignup }
                        disabled={ forceSignup }/>

                    { smartcard.withSmartcard() && this._renderSignupDetails() }

                    { enableSmartcardTransferAtSignUp &&
                        <ValidatedField type="radio"
                            form={ smartcard }
                            id="transfer"
                            field="signup"
                            label={ t('account.register.swapSeasonTicket') }
                            onChange={ () => { return onChange('signup', SignupTypes.WITH_TRANSFER);} }
                            checked={ smartcard.withTransfer() }
                            disabled={ forceSignup }/>
                    }

                    { (enableSmartcardTransferAtSignUp && smartcard.withTransfer()) && this._renderSignupDetails() }

                    <ValidatedField type="radio"
                        form={ smartcard }
                        id="none"
                        field="signup"
                        label={ t('account.register.withoutSmartcard') }
                        onChange={ () => { return onChange('signup', SignupTypes.WITHOUT_SMARTCARD);} }
                        checked={ smartcard.withoutSmartcard() }
                        disabled={ forceSignup }/>
                </div>
            );
        } else {
            return (
                <div>
                    { this._renderSignupDetails() }
                    {!hideSmartcardCheckbox &&
                        <ValidatedField
                            autoFocus
                            className="register__smartcard-checkbox"
                            type="checkbox"
                            form={ smartcard }
                            id="signup"
                            field="signup"
                            label={ t('account.confirm.smartcardsignup') }
                            onChange={ this._handleSignupToggle }
                            checked={ smartcard.withSmartcard() || forceSignup }
                            disabled={ forceSignup }
                            externalFormGroup
                        />
                    }
                </div>
            );
        }
    }
}

export { RegisterOptions };

export default connectToStores([ OrderStore ], _getStateFromStores)(RegisterOptions);
